import React from 'react';
import { withTranslation } from 'react-i18next';
// material ui
import { ShareOutlined } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme=>({
    mainDiv:{
        width:'calc(100% - 40px)',
        display:'flex',
        flexDirection:'column',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'25px 20px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
    },

    companyName:props=>({
        fontSize:'20px',
        color:props.fontDarkColor ? props.fontDarkColor : '#0F467A',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        maxWidth: '50%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }),

    topDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        width:'100%'
    },

    iconDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-around',
        width:'30%'
    },

    chatIconDiv:props=> ({
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center',
        cursor:'pointer',
        "& svg":{
            color:props.fontDarkColor ? props.fontDarkColor : '#0F467A',
            fontSize:'1.7em'
        },
        "& span":{
            color:props.fontDarkColor ? props.fontDarkColor : '#0F467A',
            fontSize:'12px',
            fontWeight:'bold'
        }
    }),

    shareIcon:props=> ({
        color:props.fontDarkColor ? props.fontDarkColor : '#0F467A',
        fontSize:'1.7em',
        cursor:'pointer',
        visibility:'hidden',
        [theme.breakpoints.between('xs','md')]: {
            visibility:'visible'
        }
    }),

    descDiv:{
        alignSelf: 'center',
        outline: 'none',
        border: 'none',
        width: '100%',
        margin: '10px 0px',
        fontSize: '16px',
        color:'#000',
        fontFamily: "'Poppins', sans-serif",
        borderRadius: '8px',
        boxSizing:"border-box"
    },

    textSpan:{
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        fontFamily:"'Cairo', sans-serif"
    },

    showBtn:props=> ({
        color: props.fontDarkColor ? props.fontDarkColor : '#0F467A',
        fontSize: '13px',
        marginLeft: '8px',
        cursor:'pointer',
        fontFamily:"'Cairo', sans-serif"
    }),
}));

// Company detail template
function CompanyDetail(props) {
    const textLength = 300;
    const [showLess,setShowLess] = React.useState(true)
    const { t, i18n, fontDarkColor,companyName, description } = props;
    const classes = useStyles({fontDarkColor});
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.mainDiv}>
            <div className={classes.topDiv}>
                <span className={classes.companyName} style={{fontFamily:"'Cairo', sans-serif"}}>{companyName ? companyName : '---'}</span>
                <div className={classes.iconDiv}>
                    <ShareOutlined className={classes.shareIcon}/>
                </div>

            </div>
            <div className={classes.descDiv}>
                {description && description.length < textLength ?
                    <span className={classes.textSpan} style={{fontFamily:"'Cairo', sans-serif"}}>{description}</span>
                :
                showLess ? 
                    <>
                    <span className={classes.textSpan}>{description && description.slice(0,textLength)}</span>
                    <span className={classes.showBtn} style={{fontFamily}} onClick={()=> setShowLess(false)}>{t('companyPage.showmore')}</span>
                    </>
                :
                    <>
                    <span className={classes.textSpan}>{description}</span>
                    <span className={classes.showBtn} style={{fontFamily}} onClick={()=> setShowLess(true)}>{t('companyPage.showless')}</span>
                    </>
                }
            </div>
        </div>
    )
}

export default withTranslation('common')(CompanyDetail);